// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const SocialTumblrIcon = (props?: any) => <Icon {...props} dangerouslySetIcon={'<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16.13 17.46c-.29.15-.942.3-1.376.3-1.377.076-1.667-.979-1.667-1.807v-5.648h3.478V7.594h-3.478V3h-2.536c-.073 0-.145.075-.145.15C10.26 4.582 9.609 6.992 7 7.97v2.335h1.74v5.874c0 2.033 1.448 4.895 5.216 4.82 1.305 0 2.682-.603 3.044-1.055l-.87-2.485z" fill="currentColor"/></svg>'} />;

(SocialTumblrIcon as any).displayName = 'SocialTumblrIcon';

export default SocialTumblrIcon;
